import { Component, OnInit } from '@angular/core';
import { DialogManagerService } from '@src/services';
import { chatbotActions } from '@src/store/reducers/chatbotReducer';
import { Store } from '@src/store';
//import { userActions } from '@src/store/reducers/userReducer';
import { cloneDeep } from 'lodash';
//import { agentActions } from '@src/store/reducers/agentReducer';
//import { ClusterDialogComponent } from '@app/shared/components/dialogs/cluster-dialog/cluster-dialog.component';


export interface IChatbot {
    Id: number;
    Name: string;
    ChatbotTypeId: number;
    ChatbotType: string;
    IsNew?: boolean;
    Configuration: any;
    Type: any;
    PromptTemplates: IPromptTempaple[];
    
}
export interface IPromptTempaple{        
        PromptTemplate: string;
        PromptType: string;
}

export interface IChatbotOpenAIConfiguration {
    Id: number;
    Name: string;
    ApiKey: string;
    Model: string;
    MaxTokens: number;
    Prompt: string;
}

@Component({
    selector: 'chatbot-management',
    template: require('./chatbot-management.component.html'),
    styles: [require('./chatbot-management.component.scss')]
})
export class ChatbotManagementComponent implements OnInit {
    public chatbots: IChatbot[];
    public chatbot: IChatbot;
    public chatbotConfig: IChatbotOpenAIConfiguration;
    private testPreventAction = false;
    private tempChatbot: any;
    private indexInList: any = 0;
    //private userId: number;
    

    constructor(private store: Store, private dialogManagerService: DialogManagerService) {
    }

    public async ngOnInit() {
        this.chatbots = await this.store.dispatch({ type: chatbotActions.GET_CHATBOTS });
        this.chatbot = this.chatbots ? this.chatbots[0] : null;
        this.tempChatbot = this.chatbots ? this.chatbots[0] : null;
        //const userDetails = await this.store.dispatch({ type: userActions.GET_CURRENT_USER_DETAILS });
        //this.userId = userDetails.data.id;
    }

    public getChatbot(selectedChatbot: any, indexInList: any) {
        if (this.testPreventAction) {
            return;
        }
        this.indexInList = indexInList;
        this.chatbot = selectedChatbot;
    }

    public addChatbot() {

        this.chatbot = {
            Id: -1, Name: 'New Chatbot', ChatbotTypeId: 1,
            ChatbotType: 'OpenAI', IsNew: true, Configuration: {},
            Type: {Id:1, Name: 'OpenAI'},
            PromptTemplates: [{  PromptTemplate: '', PromptType: 'SCRIPT_EXECUTION_ERROR'}]
        };
        this.tempChatbot = {
            Id: -1, Name: 'New Chatbot', ChatbotTypeId: 1,
            ChatbotType: 'OpenAI', IsNew: true, Configuration: {},
            Type: {Id:1, Name: 'OpenAI'},
            PromptTemplates: [{  PromptTemplate: '', PromptType: 'SCRIPT_EXECUTION_ERROR'}]
        };
        if (!this.chatbots) {
            this.chatbots = [];
        }
        //this.chatbots.push(this.chatbot);
        this.chatbots = [this.chatbot, ...this.chatbots];
    }

    public async testChatbotConnection(chatbot) {
       
        await this.store.dispatch({ type: chatbotActions.TEST_CHATBOT_CONNECTION,
            payload: { testData: chatbot }
        });
        this.testPreventAction = false;
       
    }

    public isTest() {
        return this.chatbot && this.store.getState().chatbots.test;
    }

    public onCancel() {
        this.chatbot = cloneDeep(this.tempChatbot);
    }

    public delete() {
        const onConfirm = async () => {
            if (this.chatbot.IsNew) {
                this.deleteChatbotFromList();
                return;
            }
            const response = await this.store.dispatch({
                type: chatbotActions.DELETE_CHATBOT_CONFIGURATION,
                payload: { chatbotId: this.chatbot.Id }
            });
            if (response.status === 200) {
                this.deleteChatbotFromList();
            }
        };

        const dialogData = { title: 'Delete Chatbot', action: 'delete', objectType: 'chatbot', item: this.chatbot.Name };
        this.dialogManagerService.showConfirmationDialog(dialogData, onConfirm);
    }

    private deleteChatbotFromList(): void {
        this.chatbots.splice(this.indexInList, 1);
        const index = this.chatbots.length >= this.indexInList + 1 ? this.indexInList : this.indexInList - 1;
        this.chatbot = this.chatbots ? this.chatbots[index] : null;
        this.tempChatbot = this.chatbots ? this.chatbots[index] : null;
        this.chatbots = [...this.chatbots];
    }

    public onSave(chatbotId): void {
        if (chatbotId) {
            this.chatbot.Id = chatbotId;
            this.tempChatbot.Id = chatbotId;
        }
    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/authorized/chatbot-management/chatbot-management.component.ts